import ContactBulkMessageModalController from './contact-bulk-message-modal';

export default class PicklistContactBulkMessageModalController extends ContactBulkMessageModalController {

    constructor($uibModalInstance, $injector, $scope, extendedInformation) {
        super($uibModalInstance, $injector, $scope, extendedInformation);
        this.picklist = this.extendedInformation.picklist;
    }

    _prepareSpecialFilterInformation() {
        this.specialFilterInformation = [
            {
                label: 'Picklist',
                value: this.picklist.name
            }
        ]
    }

    _prepareRecipientPostData() {
        return {
            recipient_type: 'contact',
            contacts: {
                ...this.recipientsStore.getters.selectedFilters,
                picklist_id: this.picklist.id
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/messages/controllers/modals/bulk-send/picklist-contact-bulk-message-modal.js